import type { GraphState } from 'components/Graph/GraphState';
import type { PerformUndoableActionCommand } from 'components/Graph/commands/history/performUndoableAction';
import { clearSharedView } from 'components/Graph/helpers/clearSharedView';
import type { GraphData } from 'components/Graph/model/GraphData';
import type { DraftStateUpdater } from 'utils/react/StateProxy';

/**
 * Cover common logic of all node collapsing and uncollapsing commands:
 * - undo = just put back related fields from current graphs
 * - redo = apply some transformation on draft.graph
 */
export const createNodeCollapsingUndoableAction = (
  updateState: DraftStateUpdater<GraphState>,
  originalGraph: GraphData,
  applyOnGraph: (graph: GraphData) => GraphData,
): PerformUndoableActionCommand => ({
  undo: () => {
    updateState((draft) => {
      clearSharedView(draft);
      draft.graph.hiddenNodes = originalGraph.hiddenNodes;
      draft.graph.nodes = originalGraph.nodes;
      draft.graph.edges = originalGraph.edges;
      draft.graph.nodesEdgesMap = originalGraph.nodesEdgesMap;
      draft.graph.collapsedNodeGroups = originalGraph.collapsedNodeGroups;
      draft.graph.selectedNodeIds = originalGraph.selectedNodeIds;
    });
  },
  redo: () => {
    updateState((draft) => {
      clearSharedView(draft);
      draft.graph = applyOnGraph(draft.graph);
    });
  },
});
